import { DateTime } from 'luxon'

import { ITimeAndCityLocalizable } from './ITimeAndCityLocalizable'
import { TimeStepType } from './TimeStepTypes'

export abstract class TimeStep {
  protected type?: TimeStepType

  constructor(readonly snapshot: ITimeAndCityLocalizable, readonly timestamp: DateTime, timeStepType?: TimeStepType) {
    this.timestamp = timestamp.setZone(this.snapshot.city.getTimezone())

    this.type = timeStepType
  }

  get epochSeconds(): number {
    return this.timestamp.toSeconds()
  }

  /**
   * Return the amount of seconds between this timestamp and dt.
   * @return a number < 0 when this timestamp is before dt, == 0 when this timestep occurred at dt and > 0 when this timestep occurred after dt.
   *
   */
  secondsBetween(dt: DateTime | undefined | null): number {
    if (dt === undefined || dt === null) return Number.NaN
    return this.epochSeconds - dt.toSeconds()
  }

  timeStampAsString(fmt = 'yyyy-MM-dd HH:mm'): string {
    return this.timestamp.toFormat(fmt)
  }

  private getType(): TimeStepType {
    if (this.type) {
      return this.type
    }

    const referenceTimeStep = this.snapshot.getReference()
    if (!referenceTimeStep) {
      throw Error('Reference time step must be set properly.')
    }

    if (this.timestamp > referenceTimeStep.timestamp) {
      this.type = 'Forecast'
    } else if (this.timestamp < referenceTimeStep.timestamp) {
      this.type = 'History'
    } else {
      this.type = 'Reference'
    }

    return this.type
  }

  public isHistory(): boolean {
    return this.getType() === 'History'
  }

  public isReference(): boolean {
    return this.getType() === 'Reference'
  }

  public isForecast(): boolean {
    return this.getType() === 'Forecast'
  }

  public isMax(): boolean {
    return this.getType() === 'Max'
  }

  public abstract isEmpty(): boolean
}
